<template>

  <div class="vflex">

    <div class="vflex-row-0 vflex-header p-3">
      <div class="page-title">
        <div class="title">
          <h4>{{ $t('Shared candidates') }}</h4>
        </div>
        <div class="btn-row">
          <div class="form-inline">
            <input-keyword
              @input="setKeywords"
              :placeholder="$t('Search')"
              class="mr-2" />
          </div>
        </div>
      </div>
    </div>

    <div class="vflex-row-1">
      
      <Paginaty
        :total="paginate.total"
        :pages="paginate.pages"
        :page="paginate.page"
        :creating="creating"
        :loading="loading"
        @changePage="loadData">
        
        <template slot="content">
          <table class="table">
            <thead>
              <tr>
                <th-sort
                  field="candidates"
                  :value="sort"
                  @input="setSort">{{ $t('Candidates') }}</th-sort>
                <th-sort
                  field="job_id"
                  :value="sort"
                  @input="setSort">{{ $t('Job') }}</th-sort>
                <th-sort
                  field="to"
                  :value="sort"
                  @input="setSort">Para</th-sort>
                <th-sort
                  field="url"
                  :value="sort"
                  @input="setSort">Url</th-sort>
                <th-sort
                  field="expired_at"
                  :value="sort"
                  @input="setSort">{{ $t('Expiration') }}</th-sort>
                <th-sort
                  field="created_at"
                  :value="sort"
                  @input="setSort">{{ $t('Created at') }}</th-sort>
              </tr>
            </thead>
            <tbody>
              <tr 
                v-for="(item, index) in shareCandidates"
                :key="index">
                <td class="text-truncate"><a href="javascript:void(0)" @click="showEditModal(item)">{{ $tc('n_candidates', item.candidates.length, { count: item.candidates.length })  }}</a></td>
                <td class="text-truncate">{{ item.job_id.title }}</td>
                <td class="text-truncate"><div v-if="item.to">{{ item.to.name }} <span v-if="item.to.name !== item.to.email">({{ item.to.email }})</span></div></td>
                <td class="text-truncate"><input type="text" class="input-url form-control form-control-sm" :value="item.url"></td>
                <td class="text-truncate">{{ $d(new Date(item.expired_at), 'short') }}</td>
                <td class="text-truncate">{{ $d(new Date(item.created_at), 'short') }}</td>
              </tr>
            </tbody>
          </table>
        </template>

        <template slot="noresults">
          {{ $t('There are no items') }}
        </template>

      </Paginaty>

      <MassiveShareCandidate
        v-if="modal_select"
        :initShare="modal_select" 
        @hideModal="hideModal ()" 
        @deleted="loadData(); hideModal()" 
        @saved="loadData(paginate.page); hideModal()" />

    </div>

  </div>

</template>

<script>
import InputKeyword from '@/components/Fields/InputKeyword'
import ThSort from '@/components/Parts/ThSort'
import MassiveShareCandidate from '@/components/MassiveShareCandidate/MassiveShareCandidate'
import Paginaty from '@/components/Paginaty/Paginaty'

export default {
  name: 'ShareCandidate',
  components: {
    ThSort,
    InputKeyword,
    MassiveShareCandidate,
    Paginaty
  },
  data () {
    return {
      creating: true,
      loading: true,
      filters: {},
      sort: '-created_at',
      modal_select: null
    }
  },
  computed: {
    shareCandidates () {
      return this.$store.getters.getShareCandidates
    },
    paginate () {
      return this.$store.getters.getShareCandidatesPaginate
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    /*
    loadData
    */
    loadData (page) {
      const params = {
        ...this.filters,
        page: page,
        sort: this.sort,
        limit: this.$default.limit
      }

      this.loading = true

      this.$store
      .dispatch('selectShareCandidates', params)
      .then((result) => {
        if (result.docs.length === 0 && result.page > 1) this.loadData(1)
        this.loading = this.creating = false
      })
    },
    /*
    modal
    */
    showCreateModal () {
      this.modal_select = {}
    },
    showEditModal (item) {
      this.modal_select = item
    },
    hideModal () {
      this.modal_select = false
    },
    /*
    filters
    */
    setKeywords (keywords) {
      this.filters = keywords ? {name: '~' + keywords} : {}
      this.loadData(1)
    },
    setSort (sort) {
      this.sort = sort
      this.loadData(1)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.input-url {
  min-width: 160px;
  margin: -4px 0;
  border: 0;
  background: rgba(0,0,0,0.1);
}
</style>



// WEBPACK FOOTER //
// src/components/ShareCandidate/ShareCandidate.vue